import { defineComponent, h, ref, watch } from 'vue';
import { FormRange } from '@components/form';

export const SmoothenStrength = defineComponent({
    setup() {
        const inner_sensitivity = ref(global_smoothen_strength);

        watch(
            () => inner_sensitivity.value,
            (x) => global_smoothen_strength = x,
        );

        return () => [
            h('p', 'Configure the strength of smoothening operations.'),

            h(FormRange, {
                min: 0,
                max: 1,
                step: 0.05,
                percentage: true,
                value: inner_sensitivity.value,
                'onUpdate:value': x => inner_sensitivity.value = x,
                labels: [
                    { label: 'Faint', value: 0 },
                    { label: 'Soft', value: 0.25 },
                    { label: 'Regular', value: 0.5 },
                    { label: 'Firm', value: 0.75 },
                    { label: 'Strong', value: 1 },
                ],
            }),
        ];
    },
});
